import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RestResponse } from '../models/restResponse.mode';
import { Service } from '../models/service.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {
  private readonly baseUrl = `${environment.base_url}/services`;

  constructor(private http: HttpClient) {}

  getAll(searchTerm: string, active: boolean, page: number): Observable<RestResponse<Service[]>> {
    const search = searchTerm || '';
    return this.http.get<RestResponse<Service[]>>(
      `${this.baseUrl}/list?search=${search}&active=${active}&page=${page}`);
  }

  getById(id: number): Observable<RestResponse<Service>> {
    return this.http.get<RestResponse<Service>>(`${this.baseUrl}/find/${id}`);
  }

  create(service: Service): Observable<Service> {
    return this.http.post<Service>(`${this.baseUrl}/save`, service);
  }

  update(id: number, service: Service): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, service);
  }
}
